// extracted by mini-css-extract-plugin
module.exports = {"bannerImageOverlay":"style_bannerImageOverlay__14j7a","bannerTitulo":"style_bannerTitulo__2AFmA","sectionStyle":"style_sectionStyle__3mhGu"};